import TableColorForm from './TableColorForm';

export default TableColorForm;
